import { FiltroItem } from "./FiltroItem";

export class Filtro {
  idFiltro?: number;
  nomeFiltro: string;
  loginUsuario?: string;

  filtroItem?: FiltroItem[];

  filtroExcluir?: FiltroItem[];
}